import { api } from './api';

export type EdgeOutboxSummary = Record<string, any>;
export type SqliteQuickCheckResult = {
  ok?: boolean;
  db_path?: string;
  exists?: boolean;
  result?: string;
  skipped?: string;
  error?: string;
  detail?: string;
  device_id?: string;
  ip_address?: string;
};

export type DrillDResult = Record<string, any>;

export const drContinuityApi = {
  async getOutboxSummary(deviceId: string): Promise<EdgeOutboxSummary> {
    const r = await api.get(`/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/outbox/summary`);
    return r.data;
  },

  async sqliteQuickCheck(deviceId: string): Promise<SqliteQuickCheckResult> {
    const r = await api.get(
      `/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/outbox/sqlite_quick_check`
    );
    return r.data;
  },

  async runCorruptEvidenceQuarantineDrill(
    deviceId: string,
    payload: { incident_id?: string; wait_sec?: number } = {}
  ): Promise<DrillDResult> {
    const r = await api.post(
      `/api/v1/pipeline/devices/${encodeURIComponent(deviceId)}/edge/drills/corrupt_evidence_quarantine`,
      payload || {}
    );
    return r.data;
  },
};

